import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const FEATURES = [
  {
    title: "Trusted Across Sectors",
    text: "Businesses across industries rely on Krijo for critical hiring and technology delivery.",
  },
  {
    title: "Experienced Professionals",
    text: "A seasoned team of HR specialists and technology experts working as one unit.",
  },
  {
    title: "Agile & Scalable",
    text: "Solutions tailored to your needs — built to flex as your business grows.",
  },
  {
    title: "Long-Term Partnership",
    text: "Committed to quality delivery and relationships that outlast any single project.",
  },
];

export default function WhyKrijo() {
  return (
    <section id="why-krijo" data-testid="why-krijo-section" className="py-20 lg:py-28 relative bg-[#050942]/50 border-y border-white/5">
      <div className="absolute -top-24 left-1/3 w-[400px] h-[400px] rounded-full bg-[#F89335]/8 blur-[120px] pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#F89335]">Why Krijo</p>
          <h2 data-testid="why-krijo-title" className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Built on Trust, <span className="text-gradient-gold">Driven by Results</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              data-testid={`why-card-${i + 1}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glass-card rounded-2xl p-7"
            >
              <span className="w-12 h-12 rounded-xl bg-[#F89335]/15 flex items-center justify-center">
                <CheckCircle2 size={24} className="text-[#F89335]" />
              </span>
              <h3 className="mt-5 font-['Poppins'] font-semibold text-lg">{f.title}</h3>
              <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{f.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
